import script from "./CustomCalendarField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomCalendarField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomCalendarField.vue?vue&type=style&index=0&id=081e040b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081e040b"]])

export default __exports__